'use client';

import { motion, useReducedMotion } from 'motion/react';
import { useTranslations } from 'next-intl';
import { Children, isValidElement } from 'react';
import styles from './SearchControls.module.scss';

interface SearchControlsProps {
  children: React.ReactNode;
}

// Match --motion-ease-out from the global token system.
const EASE_OUT = [0.215, 0.61, 0.355, 1] as const;

export const SearchControls: React.FC<SearchControlsProps> = ({ children }) => {
  const t = useTranslations('pages.search.controls');
  const shouldReduceMotion = useReducedMotion();
  const items = Children.toArray(children);

  return (
    <section className={styles.wrapper} aria-label={t('ariaLabel')}>
      {items.map((child, index) => {
        const key = isValidElement(child) && child.key !== null ? child.key : `child-${index}`;
        return (
          <motion.div
            key={key}
            layout={shouldReduceMotion ? false : 'position'}
            transition={{ duration: 0.24, ease: EASE_OUT }}
          >
            {child}
          </motion.div>
        );
      })}
    </section>
  );
};
